export const single_roulette_rules_en = [
  // Page 1: Game Introduction & Game Modes
  "Assign roles offline with a single device! Set the total number of players and roles, and roles will be randomly assigned.",
  "Roulette Mode",
  "Players check their roles one by one in order. Pass the device to the next player after checking your role.",
  "Moderator Mode",
  "View all players' role assignment results at once. Use this when a moderator is running the game.",

  // Page 2: How to Use
  "How to Use",
  "Set Total Players",
  "Set the total number of players participating in the game",
  "Select Game Mode",
  "Choose between Roulette Mode or Moderator Mode",
  "Role Settings",
  "Set basic roles and special roles (optional)",
  "Start Game",
  "After completing settings, start the game and roles will be automatically assigned",

  // Page 3: Precautions & Tips
  "Precautions & Tips",
  "Precautions",
  "Make sure the total number of special roles does not exceed the total number of players",
  "In Roulette Mode, be sure to pass the device to the next player after checking your role",
  "When restarting the game, roles will be randomly reassigned",
  "Secret Vote Feature",
  "After all players confirm their roles, you can conduct a secret agree/disagree vote. Players vote one by one by passing the device around, and results are shown after all votes are cast.",
  "Usage Tips",
  "Use it for various role games like Mafia, Lier game, etc.",
  "Easily assign roles even without role cards",
  "Setting Example: Mafia Game (8 players)",
  "Basic Role: Citizen | Special Roles: 2 Mafia, 1 Police, 1 Doctor\\nResult: 4 Citizens + 4 Special Roles = Total 8 players",

  // Page 4: Avalon Guide
  "Avalon Guide",
  "A social deduction game where Good and Evil compete through quests and deduction.",
  "Game Overview",
  "Good players must succeed quests, while Evil players try to sabotage them. Good wins if 3 quests succeed. Evil wins if 3 quests fail or by assassinating Merlin at the end.",
  "Good Faction",
  "Merlin",
  "Knows Evil players (except Mordred) but risks being assassinated if revealed.",
  "Percival",
  "Sees both Merlin and Morgana but can't tell them apart.",
  "Loyal Servant",
  "A Good player with no special information.",
  "Evil Faction",
  "Mordred",
  "An Evil player invisible to Merlin.",
  "Morgana",
  "An Evil player who appears as Merlin to Percival.",
  "Assassin",
  "Can assassinate a player at game end if Evil has lost.",
  "Oberon",
  "Unknown to other Evil players and doesn't know them.",
  "Minion of Mordred",
  "An Evil player with no special abilities.",
  "App Usage",
  "After role assignment, play the game offline",
  "Use the secret vote feature for quest results",
  "Quest members choose Success (Approve) or Fail (Reject)",
  "Recommended Setup",
  "5 players: Merlin, Percival, 2 Loyal Servants, Morgana, Assassin",
  "6 players: + 1 Loyal Servant",
  "7 players: + Oberon or Mordred",
  "8-10 players: Add more Loyal Servants and Evil characters as needed",

  // Page 5: Mafia Guide
  "Mafia Guide",
  "A classic social deduction game where citizens must identify and eliminate mafia members.",
  "Game Overview",
  "Mafia members try to eliminate citizens at night, while citizens use discussion and voting to eliminate mafia during the day. Citizens win by eliminating all mafia. Mafia wins when they equal or outnumber citizens.",
  "Citizen Faction",
  "Citizen",
  "A good player with no special abilities. Must use logic and discussion.",
  "Police",
  "Can investigate one player each night to learn their identity.",
  "Doctor",
  "Can protect one player each night from mafia attacks.",
  "Mafia Faction",
  "Mafia",
  "Knows all other mafia members. Can eliminate one citizen each night.",
  "Gameplay Flow",
  "Night Phase: Players close eyes. Mafia wakes and chooses a victim. Police investigates. Doctor protects.",
  "Day Phase: Victim is revealed. Discussion and debate. Players nominate and vote to eliminate someone.",
  "Repeat until one side wins.",
  "Offline Usage",
  "Use Single Role Roulette to assign roles only, then play the actual game offline.",
  "Recommended Setup",
  "7 players: 2 Mafia, 1 Police, 1 Doctor, 3 Citizens",
  "9 players: 2 Mafia, 1 Police, 1 Doctor, 5 Citizens",
  "12+ players: 3 Mafia, 1 Police, 1 Doctor, remaining Citizens",
];

export const single_roulette_rules_ko = [
  // Page 1: 게임 소개 및 게임 모드
  "1대의 기기로 오프라인에서 역할을 배정할 수 있습니다. 총 인원 수와 역할을 설정하면 랜덤하게 역할을 배정해드립니다.",
  "룰렛 모드",
  "한 명씩 순서대로 역할을 확인할 수 있는 모드입니다. 역할 확인 후 다음 플레이어에게 기기를 넘겨주세요.",
  "사회자 모드",
  "모든 플레이어의 역할 배정 결과를 한 번에 볼 수 있습니다. 사회자가 게임을 진행할 때 사용합니다.",

  // Page 2: 사용 방법
  "사용 방법",
  "1. 총 인원 수 설정",
  "게임에 참여할 총 인원 수를 설정합니다",
  "2. 게임 모드 선택",
  "룰렛 모드 또는 사회자 모드를 선택합니다",
  "3. 역할 설정",
  "기본 역할과 특수 역할을 세팅합니다",
  "4. 게임 시작",
  "설정 완료 후 게임을 시작하면 자동으로 역할이 배정됩니다",

  // Page 3: 주의사항 및 팁
  "주의사항 & 팁",
  "주의사항",
  "특수 역할의 총 인원이 전체 인원을 초과하지 않도록 설정해주세요",
  "룰렛 모드에서는 역할 확인 후 반드시 다음 플레이어에게 넘겨주세요",
  "게임 재시작 시 역할이 다시 랜덤으로 배정됩니다",
  "비공개 찬반투표 기능",
  "모든 플레이어가 역할 확인을 완료한 후, 비공개 찬반투표를 진행할 수 있습니다. 핸드폰을 돌려가며 한 명씩 투표하고, 모든 투표가 완료되면 결과가 표시됩니다.",
  "활용 팁",
  "마피아, 라이어 게임 등 다양한 역할 게임에 활용하세요",
  "역할 카드가 없어도 쉽게 역할 배정을 할 수 있습니다",
  "설정 예제: 마피아 게임 (8명)",
  "기본 역할: 시민 | 특수 역할: 마피아 2명, 경찰 1명, 의사 1명\\n결과: 시민 4명 + 특수 역할 4명 = 총 8명",

  // Page 4: 아발론 가이드
  "아발론 가이드",
  "선과 악이 퀘스트와 추리를 통해 경쟁하는 소셜 디덕션 게임입니다.",
  "게임 개요",
  "선 진영은 퀘스트를 성공시켜야 하고, 악 진영은 퀘스트를 실패시켜야 합니다. 퀘스트 3개 성공 시 선 승리. 퀘스트 3개 실패 또는 멀린 암살 성공 시 악 승리.",
  "선 진영",
  "멀린",
  "모드레드를 제외한 악의 세력을 알고 있지만, 정체가 드러나면 암살당할 위험이 있습니다.",
  "퍼시벌",
  "멀린과 모르가나를 볼 수 있지만, 둘 중 누가 진짜 멀린인지 구별할 수 없습니다.",
  "충신",
  "특별한 정보가 없는 선의 세력입니다.",
  "악 진영",
  "모드레드",
  "멀린에게 보이지 않는 악의 세력입니다.",
  "모르가나",
  "퍼시벌에게 멀린처럼 보이는 악의 세력입니다.",
  "암살자",
  "게임 종료 시 악이 패배했다면 멀린을 암살할 수 있습니다.",
  "오베론",
  "다른 악의 세력을 알 수 없고, 다른 악의 세력도 오베론을 알 수 없습니다.",
  "미니언",
  "특별한 능력이 없는 악의 세력입니다.",
  "앱 활용법",
  "역할 배정 후 게임은 오프라인으로 진행합니다",
  "원정 결과 투표 시 비공개 찬반투표 기능을 활용하세요",
  "원정에 간 인원들이 성공(찬성) 또는 실패(반대)를 선택합니다",
  "추천 구성",
  "5인: 멀린, 퍼시벌, 충신 2명, 모르가나, 암살자",
  "6인: + 충신 1명",
  "7인: + 오베론 또는 모드레드",
  "8-10인: 필요에 따라 충신과 악 캐릭터 추가",

  // Page 5: 마피아 가이드
  "마피아 가이드",
  "시민들이 마피아를 찾아내고 제거해야 하는 고전 소셜 디덕션 게임입니다.",
  "게임 개요",
  "마피아는 밤에 시민을 제거하고, 시민은 낮의 토론과 투표로 마피아를 제거합니다. 시민은 모든 마피아를 제거하면 승리. 마피아는 시민과 동수 이상이 되면 승리.",
  "시민 진영",
  "시민",
  "특별한 능력이 없는 선량한 시민입니다. 논리와 토론으로 마피아를 찾아야 합니다.",
  "경찰",
  "매일 밤 한 명을 조사하여 정체를 알 수 있습니다.",
  "의사",
  "매일 밤 한 명을 마피아의 공격으로부터 보호할 수 있습니다.",
  "마피아 진영",
  "마피아",
  "다른 모든 마피아를 알고 있습니다. 매일 밤 시민 한 명을 제거할 수 있습니다.",
  "게임 진행",
  "밤 단계: 모두 눈을 감음. 마피아가 일어나 희생자 선택. 경찰 조사. 의사 보호.",
  "낮 단계: 희생자 공개. 토론 및 논쟁. 투표로 한 명 제거.",
  "한 진영이 승리할 때까지 반복.",
  "오프라인 활용",
  "싱글 역할 룰렛으로 역할만 배정하고, 실제 게임은 오프라인으로 진행하세요.",
  "추천 구성",
  "7인: 마피아 2명, 경찰 1명, 의사 1명, 시민 3명",
  "9인: 마피아 2명, 경찰 1명, 의사 1명, 시민 5명",
  "12인 이상: 마피아 3명, 경찰 1명, 의사 1명, 나머지 시민",
];
